import { useEffect, useState } from "react";

const KEY = "gauntlet_demo_mode";
const EVT = "gauntlet-demo-change";

export const isDemo = () => localStorage.getItem(KEY) === "1";
export const setDemo = (on) => {
  localStorage.setItem(KEY, on ? "1" : "0");
  window.dispatchEvent(new Event(EVT));
};

export function useDemoMode() {
  const [on, setOn] = useState(isDemo());
  useEffect(() => {
    const h = () => setOn(isDemo());
    window.addEventListener(EVT, h);
    return () => window.removeEventListener(EVT, h);
  }, []);
  return [on, setDemo];
}

export const BUILDER = { name: "Jayaprakash Dirisala", email: "jayaprakash.dirisala@gmail.com" };
